"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseURL = exports.SIZE_OPTIONS = void 0;
var SIZE_OPTIONS = {
  EXTRASMALL: "extraSmall",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
  DISPLAY: "display"
};
exports.SIZE_OPTIONS = SIZE_OPTIONS;
var baseURL = "//images.kiwi.com";
exports.baseURL = baseURL;